import {Component, Inject, OnInit, QueryList, ViewChild, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Student, StudentAddComment} from "../../shared/interface/roster.interface";
import {UserComment} from "../../shared/interface/comment.interface";
import {MatTable} from "@angular/material/table";
import {RosterService} from "../../shared/roster.service";
import {AlertService} from "../../shared/services/alert.service";


@Component({
    selector: 'app-roster-roster-view-comment',
    templateUrl: './roster-view-comment.component.html',
    styleUrls: ['./roster-view-comment.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class RosterViewCommentComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<RosterViewCommentComponent>,
        public rosterService: RosterService,
        private alert : AlertService,
        @Inject(MAT_DIALOG_DATA) public data: Student
    ) {
    }


    displayedColumns: string[] = ['comment', 'dateCreated', 'createdBy', 'canDelete'];

    @ViewChild(MatTable) table: MatTable<Array<UserComment>>;

    //local variables that is needed
    ngOnInit(): void {
         this.data.comment.sort(function(a,b) {
             return b.id - a.id
         });
    }


    deleteComment(userComment: UserComment) {
        this.alert.confirm({
            title: 'Delete Note?',
            text: userComment.comment,
            callBack: {
                this: this,
                function: (result: boolean) => {
                    if (result === true) {
                        const index = this.data.comment.indexOf(userComment, 0);
                        this.rosterService.deleteOneStudentComment(this.data, userComment).subscribe((result: StudentAddComment) => {

                        });

                        if (index > -1) {
                            this.data.comment.splice(index, 1);
                        }
                        this.table.renderRows();
                    }
                }
            }
        });

    }

    onClose() {
        this.dialogRef.close(this.data);
    }

}
